module.exports = __webpack_public_path__ + "img/pdiaz.f6823637.png";